import { render, staticRenderFns } from "./DetailJuping.vue?vue&type=template&id=a69b0ac2&scoped=true"
import script from "./DetailJuping.vue?vue&type=script&lang=js"
export * from "./DetailJuping.vue?vue&type=script&lang=js"
import style0 from "./DetailJuping.vue?vue&type=style&index=0&id=a69b0ac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69b0ac2",
  null
  
)

export default component.exports